
import pzGoodsInfo from '@/components/Bargain/pz-goods-info'
export default {
	components: {
		pzGoodsInfo
	},
	props: {
		/**
		 * Dialog 标题及其他业务参数
		 */
		params: {
			type: Object,
			default: {}
		},
		/**
		 * 展示信息
		 */
		info: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			dialogVisible: false,
			// 卖家还价金额
			newPrice: null,
			// 服务费
			serviceFee: null,
			// 到手金额
			incomeMoney: null,
			// 各种场景按钮展示
			btns: [],
			feeList: [],
			innerVisible: false,

			//是否同步砍价价格
			isSyncPrice: null,
			checkIcon: 'https://oss.pzds.com/imgv2/icon-radio_sel20.png',
			unCheckIcon: 'https://oss.pzds.com/imgv2/icon-radio_unsel20.png'
		}
	},
	computed: {
		getBuyerPrice() {
			const current = this.info?.currentBargainList?.length ? this.info.currentBargainList[this.info.currentBargainList.length - 1] : {}
			return current.buyer ? current.bargainPrice : 0
		},
		getSellerPrice() {
			const current = this.info?.currentBargainList?.length ? this.info.currentBargainList[this.info.currentBargainList.length - 1] : {}
			return !current.buyer ? current.bargainPrice : 0
		}
	},
	async mounted() {
		const { type } = this.params
		const { id, gameId, goodsCatalogueId, goodsNo } = this.info
		const buyerPrice = this.info.buyerPrice || this.getBuyerPrice
		const sellerPrice = this.info.sellerPrice || this.getSellerPrice
		try {
			const par = {
				action: {
					gameId,
					goodsCatalogueId,
					goodsNo
				}
			}
			const res = await this.$api.getFeeNew(par)

			if (!res.success) return this.$message.error(res.info)
			this.feeList = res.data
		} catch (err) {
			this.$message.error(err.message)
		}
		switch (type) {
			// 拒绝报价
			case 'REFUSE':
				this.onGetFee(buyerPrice)
				this.btns = [
					{
						name: '拒绝报价',
						type: 'default',
						handleClick: () => this.bargainRefuse(id)
					},
					{
						name: '再考虑一下',
						type: 'danger',
						handleClick: () => this.handleClose()
					}
				]
				break
			// 还价
			case 'COUNTER':
				this.onGetFee(this.newPrice)
				this.btns = [
					{
						name: '取消',
						type: 'default',
						handleClick: () => this.handleClose('BARGAIN_COUNTER_OFFER_CONSIDER')
					},
					{
						name: '确认还价',
						type: 'danger',
						handleClick: () => this.bargainCounter(id)
					}
				]
				break
			// 同意报价
			case 'AGREE':
				this.onGetFee(buyerPrice)
				this.btns = [
					{
						name: '再考虑一下',
						type: 'default',
						handleClick: () => this.handleClose('BARGAIN_QUOTE_CONSIDER')
					},
					{
						name: '确认同意',
						type: 'danger',
						handleClick: () => this.bargainAgree(id)
					}
				]
				break
			// 结束砍价
			case 'CANCEL':
				this.onGetFee(sellerPrice)
				this.btns = [
					{
						name: '确认结束',
						type: 'default',
						handleClick: () => this.bargainCancel(id)
					},
					{
						name: '再考虑一下',
						type: 'danger',
						handleClick: () => this.handleClose()
					}
				]
				break

			default:
				break
		}
	},
	methods: {
		/**
		 * 关闭 dialog
		 * @param {*} pointEvent 埋点事件
		 */
		handleClose(pointEvent) {
			if (pointEvent) {
				//埋点 同意报价/还价 考虑一下
				this.$store.dispatch('tracking/PointList', { event: pointEvent })
			}
			this.$emit('input', false)
			this.onClose()
			this.serviceFee = null
			this.incomeMoney = null
			this.newPrice = null
			this.isSyncPrice = null
		},
		onClose() {
			this.$emit('onClose', false)
		},
		/**
		 * 根据卖家报价获取对应服务费
		 * @param {*} price
		 */
		async onGetFee(price) {
			price = Number(price)
			if (!price) return
			const feeResult = []
			this.feeList.forEach(item => {
				const fee = {
					fee: 0,
					name: item.feeTypeName
				}
				const targetFee = item.fees.find(feeItem => feeItem.priceMin <= price && feeItem.priceMax > price)

				if (!targetFee) return

				if (targetFee.feeWay === 'FIXED') {
					// fee.name += '(固定)'
					fee.fee = targetFee.fee.toFixed(2)
				} else {
					// fee.name += `(费率${targetFee.fee}%)`
					fee.fee = (price * (targetFee.fee / 100)).toFixed(2)
				}

				if (Number(fee.fee) === 0) return
				feeResult.push(fee)
			})
			this.serviceFee = feeResult.reduce((total, item) => total + Number(item.fee), 0).toFixed(2)
			this.incomeMoney = (price - feeResult.reduce((total, item) => total + Number(item.fee), 0)).toFixed(2)
		},
		/**
		 * 卖家结束砍价
		 * @param {*} id
		 */
		async bargainCancel() {
			try {
				const { id, bargainId } = this.info
				const par = {
					action: {
						id: id || bargainId
					}
				}
				const res = await this.$api.cancelBargainSellerApi(par)
				if (!res.success) return this.$message.error(res.info)
				// 关闭 dialog
				this.handleClose()
				// 通知父组件刷新列表
				this.$emit('listRefresh')
				this.onClose()
				this.$message.success(res.info || '操作成功！')
			} catch (error) {
				this.$message.error(error.message)
			}
		},
		/**
		 * 卖家拒绝砍价
		 * @param {*} id
		 */
		async bargainRefuse() {
			try {
				const { id, bargainId } = this.info
				const par = {
					action: {
						id: id || bargainId
					}
				}
				const res = await this.$api.refuseBargainSellerApi(par)
				if (!res.success) return this.$message.error(res.info)
				// 关闭 dialog
				this.handleClose()
				// 通知父组件刷新列表
				this.$emit('listRefresh')
				this.onClose()
				this.$message.success(res.info || '操作成功！')
			} catch (error) {
				this.$message.error(error.message)
			}
		},
		/**
		 * 卖家同意报价
		 * @param {*} id
		 */
		async bargainAgree() {
			if (this.isSyncPrice === null) {
				return this.$message.error('请完成选项')
			}
			try {
				const { id, bargainId } = this.info
				const par = {
					action: {
						id: id || bargainId,
						updatePrice: this.isSyncPrice
					}
				}
				const res = await this.$api.agreeBargainSellerApi(par)
				//埋点 砍价报价同意-是否同步
				this.$store.dispatch('tracking/PointList', { event: 'BARGAIN_QUOTE_AGREE', eventId: this.isSyncPrice })
				if (!res.success) return this.$message.error(res.info)
				// 关闭 dialog
				this.handleClose()
				// 通知父组件刷新列表
				this.$emit('listRefresh')
				this.onClose()
				this.$message.success(res.info || '操作成功！')
			} catch (error) {
				this.$message.error(error.message)
			}
		},
		/**
		 * 卖家还价
		 * @param {*} id
		 */
		async bargainCounter(id) {
			// 卖家还价判空
			if (!this.newPrice) {
				this.$message.error('请输入还价金额！')
				this.$refs.pieceRef.focus()
				return
			}
			// 禁止以0开始的数字输入
			if (/^(0+)|[^\d]+/g.test(this.newPrice)) {
				this.$message.error('请输入正整数的金额')
				this.$refs.pieceRef.focus()
				return
			}
			// // 卖家还价金额大于当前商品原价给出提示  其他提示由后端提供
			// if (Number(this.newPrice) >= Number(this.info.goodsPrice)) {
			// 	this.$message.error(`您的报价需要低于￥${this.info.goodsPrice}`)
			// 	this.$refs.pieceRef.focus()
			// 	return
			// }
			this.onGetFee(this.newPrice)
			this.innerVisible = true
		},
		/**
		 * 卖家还价二次确认
		 */
		async bargainConfirm() {
			if (this.isSyncPrice === null) {
				return this.$message.error('请完成选项')
			}

			try {
				const { id, bargainId } = this.info
				const par = {
					action: {
						id: id || bargainId,
						sellerPrice: this.newPrice,
						updatePrice: this.isSyncPrice
					}
				}
				const res = await this.$api.counterBargainSellerApi(par)
				//埋点 砍价还价同意-是否同步原价
				this.$store.dispatch('tracking/PointList', { event: 'BARGAIN_COUNTER_OFFER_AGREE', eventId: this.isSyncPrice })
				if (!res.success) return this.$message.error(res.info)
				// 关闭 dialog
				this.handleClose()
				// 通知父组件刷新列表
				this.$emit('listRefresh')
				this.onClose()
				this.$message.success(res.info || '操作成功！')
			} catch (error) {
				this.$message.error(error.message)
			}
		},
		/**
		 * 选择是否同步砍价
		 */
		checkSyncHandler(checking) {
			this.isSyncPrice = checking
		},
		/**
		 * 输入框input 事件
		 * @param {*} e
		 */
		onInput(e) {
			this.onGetFee(e)
		}
	}
}
